import type { FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { passwordRequirements } from '@/modules/Auth/utils/passwordSchema';
import { Icon } from '@/components/elements/Icon';

export const PasswordRequirementsChecklist: FC<
  PasswordRequirementsChecklistProps
> = ({ password }) => {
  const t = useT();

  return (
    <Flex
      flexDir="column"
      gap="s"
      p="s"
      bg="background.brandLight"
      borderRadius="xs"
    >
      <Text color="content.secondary" fontSize="l">
        {t('screens.register.step2.requirementsTitle')}
      </Text>
      {passwordRequirements.map(({ key, test, messageKey }) => {
        const isValid = test(password);

        return (
          <Flex key={key} align="center" gap="xs">
            <Icon
              width="16px"
              height="16px"
              iconName={isValid ? 'CheckCircle' : 'Close'}
              color={isValid ? 'alert.success' : 'content.secondary'}
            />
            <Text
              size="l"
              color={isValid ? 'alert.success' : 'content.secondary'}
            >
              {t(messageKey)}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

type PasswordRequirementsChecklistProps = {
  password: string;
};
